import { ref, watch } from "vue";
import { defineStore } from "pinia";

const STORAGE_KEY = "menuLayout";

// Preferencia de posición del menú en escritorio ('lateral' | 'top').
// En mobile no aplica: siempre se usa el topbar + sidebar deslizable.
export const useMenuLayoutStore = defineStore("menuLayout", () => {
  const initial = localStorage.getItem(STORAGE_KEY) === "top" ? "top" : "lateral";

  const layout = ref(initial);

  const setLayout = (value) => {
    layout.value = value === "top" ? "top" : "lateral";
  };

  watch(layout, (value) => {
    localStorage.setItem(STORAGE_KEY, value);
  });

  return { layout, setLayout };
});
